export type RouterConfig = {
  id: string;
  title: string;
  path: string;
  component?: string;
  authorities?: string[];
  children?: RouterConfig[];
  meta?: {
    /**
     * 是否首页，用于同级页面默认打开
     */
    index?: boolean;
    /**
     * 可以通过该属性使用iframe
     */
    src?: string;
    /**
     * 是否允许匿名访问，既无需登录
     */
    allowAnonymous?: boolean;
    /**
     * 类型 page 为 页面，func 为功能key
     */
    type?: "page" | "func";
    /**
     * 是否在菜单中展示
     */
    showInNav?: boolean;
  };
};

// 本地路由配置，测试的时候可以用，实际从服务器端加载
export const inLayoutPages: RouterConfig[] = [];

export const publicPages: RouterConfig[] = [
  {
    id: "layout",
    title: "应用主体",
    path: "Main",
    component: "Main/Layout",
    meta: {
      index: true,
      showInNav: false,
    },
  },
  {
    id: "login",
    title: "登录",
    path: "login",
    component: "Login/Login",
    meta: {
      allowAnonymous: true,
      showInNav: false,
      index: false,
    },
  },
];
